import Invoice from './Invoice';

export default class ZUGFeRD {
  constructor(data = {}) {
    this.id = data.id || null;
    this.fileId = data.fileId || null;
    // Optional: Source PDF file uploaded by the user (used for "conversion" workflow).
    // The backend expects `sourceFileId` (GUID) when converting an existing PDF to a ZUGFeRD PDF.
    this.sourceFileId = data.sourceFileId || data.SourceFileId || null;
    this.invoice = data.invoice ? data.invoice  instanceof Invoice ? data.invoice : new Invoice(data.invoice) : new Invoice();
    this.zugFeRDVersionId = data.zugFeRDVersionId || '230';
    this.zugFeRDProfileId = data.zugFeRDProfileId || '32';
  }

  toJSON() {
    console.log('Serializing ZUGFeRD:', this);
    return {
      id: this.id,
      fileId: this.fileId,
      sourceFileId: this.sourceFileId || this.SourceFileId || null,
      invoice: this.invoice
        ? (this.invoice instanceof Invoice ? this.invoice.toJSON() : new Invoice(this.invoice).toJSON())
        : null,
      zugFeRDVersionId: this.zugFeRDVersionId,
      zugFeRDProfileId: this.zugFeRDProfileId
    };
  }
}
